import { useEffect, useState } from 'react';
import { useAdmin } from '@/hooks/useAdmin';
import { Gift, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminTips() {
  const { authFetch } = useAdmin();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => { (async () => {
    const r = await authFetch(`${API}/admin/tips`);
    if (r.ok) setData(await r.json());
    setLoading(false);
  })(); /* eslint-disable-next-line */ }, []);

  if (loading) return <div className="p-10"><Loader2 className="animate-spin text-zinc-500" /></div>;
  const items = data?.items || [];

  return (
    <div className="p-4 md:p-6" data-testid="admin-tips">
      <div className="flex items-center gap-3 mb-5">
        <Gift className="text-red-500" size={24} />
        <div>
          <h1 className="text-2xl font-bold">Savjeti / Donacije</h1>
          <p className="text-sm text-zinc-400">Donacije primljene preko dugmeta ispod članaka (Stripe, PayPal, kripto).</p>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
        <Tile label="Ukupno donacija" value={data?.total ?? 0} accent="blue" />
        <Tile label="Iznos (EUR)" value={`${(data?.total_amount_eur || 0).toFixed(2)} €`} accent="green" />
        <Tile label="Kripto tips" value={data?.crypto_count ?? 0} accent="amber" />
        <Tile label="Stripe / PayPal" value={(data?.by_provider?.stripe || 0) + (data?.by_provider?.paypal || 0)} accent="violet" />
      </div>

      <div className="rounded-lg border border-zinc-800 overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead className="bg-zinc-900 text-xs uppercase text-zinc-400">
            <tr>
              <th className="px-3 py-2 text-left">Datum</th>
              <th className="px-3 py-2 text-left">Iznos</th>
              <th className="px-3 py-2 text-left">Provider</th>
              <th className="px-3 py-2 text-left">Od</th>
              <th className="px-3 py-2 text-left">Poruka</th>
              <th className="px-3 py-2 text-left">Članak</th>
            </tr>
          </thead>
          <tbody>
            {items.map(d => (
              <tr key={d.id} className="border-t border-zinc-800" data-testid={`tip-row-${d.id}`}>
                <td className="px-3 py-1.5 text-zinc-400 text-xs">{(d.created_at || '').slice(0, 16)}</td>
                <td className="px-3 py-1.5 text-emerald-400 font-bold">{d.amount_eur ? `${d.amount_eur} €` : '—'}</td>
                <td className="px-3 py-1.5 text-zinc-400 text-xs">{d.provider || 'other'}</td>
                <td className="px-3 py-1.5">{d.donor_name || d.email || 'Anonimno'}</td>
                <td className="px-3 py-1.5 text-zinc-400 max-w-[280px] truncate">{d.message || ''}</td>
                <td className="px-3 py-1.5 text-blue-400">{d.article_slug || '—'}</td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={6} className="text-center py-8 text-zinc-500">Još nema donacija.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function Tile({ label, value, accent = 'blue' }) {
  const colors = {
    blue: 'text-blue-400', green: 'text-emerald-400',
    amber: 'text-amber-400', violet: 'text-violet-400',
  };
  return (
    <div className="p-4 rounded-lg bg-zinc-900 border border-zinc-800">
      <p className="text-[10px] uppercase text-zinc-500">{label}</p>
      <p className={`text-2xl font-bold ${colors[accent]}`}>{value}</p>
    </div>
  );
}
